import React from 'react';
import '../Styles/PauseConfirmationModal.scss';

const PauseConfirmationModal = ({
    isOpen,
    reason,
    reasonError = '',
    onReasonChange,
    onConfirm,
    onCancel,
    isLoading = false,
    actionType = 'pause',
}) => {
    if (!isOpen) {
        return null;
    }

    let questionText = 'Bạn chắc chắn muốn tạm dừng chính sách đổi điểm?';
    if (actionType === 'resume') {
        questionText = 'Bạn chắc chắn muốn tiếp tục chính sách đổi điểm?';
    } else if (actionType === 'cancel') {
        questionText = 'Bạn chắc chắn muốn hủy chính sách đổi điểm?';
    }

    const shouldShowReason = actionType !== 'resume';

    return (
        <div className="pause-confirmation-modal-overlay" onClick={onCancel}>
            <div className="pause-confirmation-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">Thông báo</h2>
                    <button
                        type="button"
                        className="modal-close-btn"
                        onClick={onCancel}
                        aria-label="Đóng"
                    >
                        <i className="mdi mdi-close"></i>
                    </button>
                </div>
                <div className="modal-body">
                    <p className="modal-question">
                        {questionText}
                    </p>
                    {shouldShowReason && (
                        <div className="modal-input-group">
                            <label className="modal-input-label">Nhập lý do</label>
                            <input
                                type="text"
                                className={`modal-input ${reasonError ? 'has-error' : ''}`}
                                value={reason}
                                onChange={(e) => onReasonChange(e.target.value)}
                                placeholder=""
                                aria-invalid={reasonError ? 'true' : 'false'}
                            />
                            {reasonError && (
                                <span className="modal-error-message">{reasonError}</span>
                            )}
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="modal-btn modal-btn--cancel"
                        onClick={onCancel}
                    >
                        Hủy
                    </button>
                    <button
                        type="button"
                        className="modal-btn modal-btn--confirm"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        Đồng ý
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PauseConfirmationModal;

